export default "__VITE_ASSET__24f1abfc__"